import React, { Component } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import moment from 'moment'

class MsgModalBox extends Component{
    renderTaskDates = (tasks) => {
        return tasks.map((task, i) => {
            return (
                <Typography variant="body2" key={i}>
                    {"Task " + (i + 1) + " Start Date: " + moment(task.tStrtDate).format("M[/]D[/]Y") + " End Date: " + moment(task.tEndDate).format("M[/]D[/]Y")}
                    <br/>
                </Typography>
            ) 
        });
    }
    render(){
        return(
            <Card sx={{marginLeft: 0, marginRight: 0}}>
                <CardContent className="overflow-auto">
                    <Typography variant="h6">{this.props.text} {this.props.showError && 'Not '}{!this.props.edit?'Created':'Updated'}</Typography>
                    <Divider sx={{ my: 1 }} />
                    <Typography variant="body2">
                        The Details have {this.props.showError && 'Not '}been saved to the database. <br/>
                        {this.props.text === 'Customer' && !!this.props.showError? `A ${this.props.text} with the same DDD_ID exist`: ''}
                    </Typography>
                    <div className="d-flex justify-content-around">
                        {!this.props.showError && <Button style={{height: "40px",width: "10rem"}} variant="outlined" onClick={(e)=> this.props.goHome(e)}>Go Back Home</Button>}
                        {!this.props.edit &&  <Button style={{height: "40px",width: "14rem"}} variant="contained" onClick={(e)=> this.props.addNew(e)}>{(this.props.showError)? `Add ${this.props.text} Again` : `Add Another ${this.props.text}`}</Button>}
                    </div>
                    {(!this.props.edit && this.props.text === 'Task' &&this.props.taskDates.length !== 0) &&
                        <Typography variant="body2" className="mt-3">
                            {this.props.taskDates.length + (this.props.taskDates.length === 1 ? " Task has" : " Tasks have") + " been created"}
                            <br/>
                       </Typography> 
                    }
                    {(!this.props.edit && this.props.text === 'Task' && this.props.taskDates.length !== 0) && 
                            this.renderTaskDates(this.props.taskDates)
                    }
                </CardContent>
            </Card>
        )
    }
}

export default MsgModalBox;